import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { PictureInfo } from "src/app/core/survey/shared/components/photo-and-remark/photo-viewmodel";
import { FormValidationService } from "src/app/core/survey/shared/services/formValidation.service";
import { SurveyType } from "src/app/core/survey/shared/services/photo.service";
import { PhotoIndexInfo } from "src/app/shared/Models/interfaces/PhotoIndexInfo.interface";
import "../../../../../../../shared/extension/array.extension";
import { SurveyPhotoTypeEnum } from "../../../../../../../shared/Models/enums/SurveyPhotoTypeEnum";
import { InsideSurvey } from "../../../../../../../shared/Models/read";
import {
  InsideSurveyInsideInfo,
  INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
} from "../../../../config/inside-survey.magic-strings";

@Component({
  selector: "app-access-to-telco",
  templateUrl: "./access-to-telco.component.html",
  styleUrls: ["./access-to-telco.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccessToTelcoComponent),
      multi: true,
    },
  ],
})
export class AccessToTelcoComponent
  implements OnInit, ControlValueAccessor, OnDestroy
{
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  @Input() pictures: {
    telcoRoomPhotos: PictureInfo[];
    proximusEquipmentPhotos: PictureInfo[];
  };
  savedPhotoOrder: {
    telcoRoomPhotos: PhotoIndexInfo[];
    proximusEquipmentPhotos: PhotoIndexInfo[];
  } = {
    proximusEquipmentPhotos: [],
    telcoRoomPhotos: [],
  };
  unsavedPhotoOrder: {
    telcoRoomPhotos: PhotoIndexInfo[];
    proximusEquipmentPhotos: PhotoIndexInfo[];
  } = {
    proximusEquipmentPhotos: [],
    telcoRoomPhotos: [],
  };
  @Input() isAuthCanWrite: boolean;
  @Input() viewerLayer: HTMLDivElement;
  @Input() survey: InsideSurvey;

  accessToTelcoForm: FormGroup = new FormGroup({});
  isDisabled: boolean = false;
  formChanged: Subject<Partial<InsideSurvey>> = new Subject<
    Partial<InsideSurvey>
  >();
  surveyPhotoTypes = SurveyPhotoTypeEnum;

  @ViewChildren("fileInput")
  fileInputs: QueryList<ElementRef<HTMLInputElement>>;
  surveyType = SurveyType;
  surveyPhotoType = SurveyPhotoTypeEnum;
  proximusEquipmentPhotoRemarkFieldName = "proximusEquipmentPhotoRemark";
  telcoRoomPhotoRemarkFieldName = "telcoRoomIntroPhotoRemark";
  insideSurveyInsideInfo = InsideSurveyInsideInfo;

  constructor(
    private fb: FormBuilder,
    private formValidationService: FormValidationService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.buildForm();
  }

  getErrors(subTitle?: string, field?: string) {
    return this.formValidationService.getErrors(
      ...[INSIDE_SURVEY_INSIDE_TECHNICAL_INFO, subTitle, field].filter(
        (x) => !!x
      )
    );
  }

  private buildForm() {
    this.accessToTelcoForm = this.fb.group({
      accessToTelcoGeneralRemarks: [[]],
    });

    this.accessToTelcoForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => this.formChanged.next(val));
  }

  writeValue(obj: InsideSurvey): void {
    this.accessToTelcoForm.patchValue({
      ...obj,
    });
  }

  registerOnChange(fn: any): void {
    this.formChanged.pipe(takeUntil(this.destroy$)).subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched();
  }
  onTouched = () => null;

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
